import logo from "../../data/tony845logo-removebg.png";
import bground from "../../data/solid-grey-backdrop-with-streaks.jpg";
import { Link } from 'react-router-dom';

const Home = (props) => {
    const componentStyles = `
        .homeContainer {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        } 
            
        .componentLink {
            text-decoration: none;
            color: cadetblue;
            font-size: 50px;
            font-weight: 600;
        }
        .componentLink:hover {
            color: lightseagreen;
            transform: scale(1.5);
            text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
        }
        a {
            transition: all 0.3s ease;
        }
        #homeWrapper{
            background-image: url(${bground});
            background-attachment: fixed;
            background-size: cover;
        `;

    return (
    <div id='homeWrapper'>
        <style>{componentStyles}</style>
        <div className="homeContainer" style={{height: '100vh'}}>
            <img src={logo} alt="tony845 Logo" id="logo" style={{width:'50%'}} />
            <nav className="homeContainer" style={{justifyContent: 'start'}}>
                <Link to="/resume" title="The brains behind this operation" className='componentLink'>Resume</Link>
                <Link to="/nfl" title="Team stats" className='componentLink'>NFL</Link>
                <Link to="/mlb" title="Boxscore data" className='componentLink'>MLB</Link>
            </nav>
        </div>
    </div>
  );
};

export default Home;
